<div @animation *ngIf="isOpen" (@animation.done)="onAnimationEvent()" data-cy="lendio-alert">
    <mat-card appearance="outlined"
                        [class.new-theme]="newThemeActive$ | async"
                        [ngClass]="[
                                '!py-2',
                                '!px-4',
                                'lendio-alert',
                                'lendio-alert--' + level
                        ]"
                        style="display: flex; align-items: center;"
    >
        <i *ngIf="showIcon" class="lendio-alert__icon fa fa-lg fa-{{ icons[level] }}"></i>
        <div class="lendio-alert__message">
            <div [innerHtml]="message"></div>
            <div *ngIf="isAan">{{ aanDate | date:'MM/dd/yyyy, h:mm a' }}</div>
        </div>
        <div class="lendio-alert__dismiss align-items-center" *ngIf="dismissible">
            <button mat-icon-button (click)="dismiss()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </mat-card>
</div>
